// TShirtHeroFooter.tsx
import * as React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../../tgccGlobal';

const mobileBreakpoint = '@media (max-width: 768px)'; 

// For the footer background and general text
const blackThemeFooterStyle: React.CSSProperties = {
  backgroundColor: '#1A1A1A',
  color: '#fff',
  padding: '20px 20px',
  fontSize: '16px',
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  textAlign: 'center', // Center align for mobile view
  lineHeight: '1.5',
  marginTop: '25vh',
  width: '100%',
  alignItems: 'center',
  [mobileBreakpoint]: {
    padding: '0px 10px 10px 10px',
    fontSize: '14px',
    marginTop: '10vh',
    lineHeight: '1.2',
},
};


// For the hyperlinks
const blackThemeLinkStyle: React.CSSProperties = {
  color: '#fff',
  cursor: 'pointer',
  padding: '5px',
  borderRadius: '5px',
  marginRight: '5px',
  ':hover': {
    backgroundColor: '#333',
    textDecoration: 'none',
  },
  [mobileBreakpoint]: {
      padding: '3px',
      fontSize: '14px',
      margin: '5px auto',
      display: 'block',
    },
};

// For the logos
const invertedImageStyle: React.CSSProperties = {
  filter: 'invert(100%)',
  width: '75px',
  margin: '0 auto', // Center-align the logos
  display: 'none',
  [mobileBreakpoint]: {
    width: '50px',
    margin: '5px auto',
  },
  };

const logoContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  margin: '0 auto 20px',
  [mobileBreakpoint]: {
    flexDirection: 'column',
  },
};

const footerLinkContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  [mobileBreakpoint]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
};

const copyrightStyle: React.CSSProperties = {
  fontWeight: 'bolder',
  fontSize: '17px',
  [mobileBreakpoint]: {
    fontSize: '14px',
    marginTop: '20px', // Add some space above the copyright text
  },
};

class _TShirtHeroFooter extends React.Component<any, any> {
  openFAQ = () => { browserHistory.push(Tgcc.Routes.CampusFAQ) };
  openContact = () => { browserHistory.push(Tgcc.Routes.CampusContact) };
  openAbout = () => { browserHistory.push(Tgcc.Routes.CampusAbout) };
  openShipping = () => { browserHistory.push(Tgcc.Routes.CampusShipping) };
  openHowItWorks = () => { browserHistory.push(Tgcc.Routes.CampusHowItWorks) };
  openRealCampusProducts = () => { browserHistory.push(Tgcc.Routes.RealCampusProductListView) };

  renderSeparator = (key) => (
    <div style={{ color: '#fff', padding: '0 5px', display: 'inline-block', [mobileBreakpoint]: { display: 'none' } }} key={key}>|</div>
  );

  render() {
    return (
      <div style={blackThemeFooterStyle}>
        <div style={logoContainerStyle} key="logo-container">
          <img style={invertedImageStyle} src={Tgcc.ResolveUrl('~/images/newAffinityLogo.png')} alt="Affinity Logo" key="affinity-logo" />
          <img style={invertedImageStyle} src={Tgcc.ResolveUrl('~/images/CLC.png')} alt="CLC Logo" key="clc-logo" />
          <img style={invertedImageStyle} src={Tgcc.ResolveUrl('~/images/fermata.png')} alt="Fermata Logo" key="fermata-logo" />
        </div>
        
        <div style={footerLinkContainerStyle} key="links-container">
          <div onClick={this.openAbout} style={blackThemeLinkStyle} key="about">About Us</div>
          {this.renderSeparator('separator-about')}
          <div onClick={this.openContact} style={blackThemeLinkStyle} key="contact">Contact</div>
          {this.renderSeparator('separator-contact')}
          <div onClick={this.openHowItWorks} style={blackThemeLinkStyle} key="how-it-works">How It Works</div>
          {this.renderSeparator('separator-how-it-works')}
          <div onClick={this.openFAQ} style={blackThemeLinkStyle} key="faqs">FAQs</div>
          {this.renderSeparator('separator-faqs')}
          <div onClick={this.openShipping} style={blackThemeLinkStyle} key="shipping">Shipping & Returns</div>
        </div>

        <div style={copyrightStyle} key="copyright">
          &copy; 2024 BY THE GRAPHIC COW COMPANY
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
  return {
    // your state mapping
  };
};

export const TShirtHeroFooter = connect(mapStateToProps)(Radium(_TShirtHeroFooter));
